import { getRotationMatrix } from '../../../../../utils/index.ts';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import * as THREE from 'three';
import { SplatConfig } from '@/types';

interface FloorConfig {
  size: [number, number];
  position: [number, number, number];
  rotation: [number, number, number];
  color: string;
  opacity: number;
  isCollision: boolean;
  visible?: boolean;
}

export default class GsRenderController {
  splatConfig: SplatConfig;
  scene: THREE.Scene;
  private viewer: any;
  private sceneController: any;
  private renderer: THREE.WebGLRenderer;
  private camera: THREE.Camera;
  // private singleScenes: Map<any, any>;
  // private interactionScenes: Map<any, any>;
  private debugMesh?: THREE.Object3D;

  constructor(sceneController: any) {
    this.viewer = null;
    this.splatConfig = null as unknown as SplatConfig;
    this.sceneController = sceneController;
    this.renderer = this.sceneController.getRenderer();
    this.camera = this.sceneController.getCamera();
    this.scene = this.sceneController.getScene();

    // this.singleScenes = new Map();
    // this.interactionScenes = new Map(); // 加载其他scene的交互区域
  }

  // async render(): Promise<void> {}

  // animate(): void {}

  onWindowResize(): void {}

  dispose(): void {}

  async loadMesh(splatConfig: SplatConfig): Promise<void> {
    console.log('loadMesh', splatConfig);
    // this.createFloor({
    //   size: [1000, 1000],
    //   position: [0, 0, 0],
    //   rotation: [-90, 0, 8],
    //   color: '#ffffff',
    //   opacity: 1,
    //   isCollision: true,
    //   visible: false,
    // });
    if (splatConfig.meshName) {
      await this.loadSceneMesh(splatConfig.meshName, splatConfig.scale);
    } else {
      this.createFloor({
        size: [1000, 1000],
        position: [0, 0, 0],
        rotation: [-90, 0, 8],
        color: '#456636',
        opacity: 1,
        isCollision: true,
        visible: false,
      });
    }
    if (splatConfig.customMesh?.length !== 0) {
      splatConfig.customMesh?.forEach((mesh) => {
        this.createFloor(mesh);
      });
    }
  }

  loadSceneMesh(meshPath: string, scale?: number[]): Promise<void> {
    console.log('addMesh', meshPath, 'scale', scale);
    if (!meshPath) {
      console.warn('meshName is not exist');
      return Promise.reject('mesh name is not exist');
    }
    return new Promise((resolve) => {
      const loader = new GLTFLoader();
      if (!meshPath.startsWith('http')) {
        loader.setPath('./models/');
      }
      loader.load(meshPath, (gltf) => {
        const collisionWorld = gltf.scene;
        collisionWorld.rotation.y = Math.PI;
        // 设置模型缩放
        if (scale && Array.isArray(scale) && scale.length === 3) {
          collisionWorld.scale.set(scale[0], scale[1], scale[2]);
          console.log('设置模型缩放:', scale);
        }

        collisionWorld.traverse((child: THREE.Object3D) => {
          if ((child as THREE.Mesh).isMesh) {
            (child as THREE.Mesh).castShadow = true;
            (child as THREE.Mesh).receiveShadow = true;
          }
        });

        this.scene.add(collisionWorld);
        this.debugMesh = collisionWorld;
        this.sceneController.getWorldOctree().fromGraphNode(this.debugMesh);
        resolve();
      });
    });
  }

  createFloor(floorConfig: FloorConfig): void {
    console.log('createFloor', floorConfig);
    // 创建地板几何体
    const floorGeometry = new THREE.PlaneGeometry(floorConfig.size[0], floorConfig.size[1]);
    // 创建地板材质
    const floorMaterial = new THREE.MeshLambertMaterial({
      color: new THREE.Color(floorConfig.color),
      transparent: true,
      opacity: floorConfig.opacity,
    });
    // 创建地板网格
    const floor = new THREE.Mesh(floorGeometry, floorMaterial);
    floor.rotation.x = (floorConfig.rotation[0] * Math.PI) / 180; // 旋转90度使其水平
    floor.rotation.y = (floorConfig.rotation[1] * Math.PI) / 180; // 旋转90度使其水平
    floor.rotation.z = (floorConfig.rotation[2] * Math.PI) / 180; // 旋转90度使其水平
    floor.position.set(floorConfig.position[0], floorConfig.position[1], floorConfig.position[2]); // 设置在y=0的位置

    if (floorConfig.isCollision) {
      this.sceneController.getWorldOctree().fromGraphNode(floor);
      floor.receiveShadow = true; // 接收阴影
    }
    floor.visible = floorConfig.visible ?? false;
    // 添加到场景
    this.scene.add(floor);
  }

  setInfoPanelVisible(): void {}

  getConfig(config: any): SplatConfig {
    let splatConfigs: SplatConfig;
    if (Array.isArray(config.url)) {
      const configItem = config.url[0];
      splatConfigs = {
        ...config,
        url: configItem.path,
        show: false,
        position: configItem.position || config?.splashInfo?.position || [0, 0, 0],
        rotation: getRotationMatrix(configItem?.rotation) || [0, 0, -1, 0],
        scale: configItem.scale || config?.splashInfo?.scale || [1, 1, 1],
        meshName: config?.splashInfo?.meshName,
        rendererScale: config?.rendererScale || 1,
        customMesh: config?.splashInfo?.customMesh || [],
      };
    } else {
      splatConfigs = {
        ...config,
        url: config.url,
        show: false,
        position: config?.splashInfo?.position || [0, 0, 0],
        rotation: getRotationMatrix(config?.splashInfo?.rotation) || [0, 0, -1, 0],
        scale: config?.splashInfo?.scale || [1, 1, 1],
        meshName: config?.splashInfo?.meshName,
        rendererScale: config?.rendererScale || 1,
        customMesh: config?.splashInfo?.customMesh || [],
      };
    }
    return splatConfigs;
  }
}
